import { Component, OnInit, ElementRef, Renderer2, Input, Output, EventEmitter } from '@angular/core';
import { Report } from '../models/report.model';
import { ReportService } from '../report.service';
import { ReportRender } from 'src/app/models/reportRender';
import { ReportViewComponent } from '../../report-view/report-view/report-view.component';
import { Filter } from '../models/filter.model';
import { sortListByOrder } from 'src/app/reports/helpers/column.helper';
import { FilterTypeEnum } from 'src/app/reports/enums/filter-type.enum';
import { ReportSettings } from '../../report-view/report-settings/models/reportsettings.model';
import { ReportRenderComponent } from '../../report-view/report-render/report-render.component';
import { Schema, SchemaForm, SchemaFormRow } from 'src/app/reports/shared/rte-form/schema/schema.model';
import { getPropertyTypeBySystemType } from 'src/app/reports/helpers/property-type.helper';
import { PropertyType } from 'src/app/reports/shared/rte-form/schema/property-type.enum';
import { Entity } from '../../entity/entity.model';
import { Subscription } from 'rxjs';
import { ObjectValue } from 'src/app/reports/models/object-value.model';
import { QueryRequest } from 'src/app/reports/requests/query.request';
import { EntityService } from '../../entity/entity.service';
import { QueryService } from 'src/app/reports/services/query.service';

@Component({
  selector: 'app-report-menu-pre-view',
  templateUrl: './report-menu-pre-view.component.html',
  styleUrls: ['./report-menu-pre-view.component.scss']
})

export class ReportMenuPreViewComponent implements OnInit {

  @Input() id: number;
  @Input() reportViewer: boolean;

  data: Report;
  showReportViewOrRender: ReportRender = new ReportRender();
  loadReportView: ReportViewComponent;
  loadReportRender: ReportRenderComponent;
  filters: Array<Filter> = [];
  settings: ReportSettings = new ReportSettings();
  subscription: Subscription = new Subscription();
  entityList = new Entity();
  form: SchemaForm;
  schemasWithFileUpload: Schema[] = [];

  @Output() reportViewerReturn: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private reportService: ReportService,
    private entityService: EntityService,
    private queryService: QueryService) {}

  ngOnInit(): void {
    this.showChild();
    this.getData();
  }

  getData() {
    const obj = new Report();
    obj.Id = this.id;
    this.reportService.getById(obj).subscribe(result => {
      this.data = result.Data[0];
      this.filters = this.getAllFilters();
      this.form = this.convertFilterToSchemaForm();
    });
  }

  showChild() {
    this.showReportViewOrRender.showReportView = true;
    this.showReportViewOrRender.showReportRender = false;
  }

  getReport(): Report {
    return this.data;
  }

  feedbackReportView(response: ReportViewComponent) {
    this.loadReportView = response;
  }

  feedbackReportViewReturn(response: boolean) {
    this.reportViewerReturn.emit(response);
  }

  feedbackReportRender(response: ReportRenderComponent) {
    this.loadReportRender = response;
  }

  getFilterByName(name: string ): Filter {
    const list = this.filters && this.filters.length > 0 ? this.filters : this.getAllFilters();
    return list.find(x => x.Name === name);
  }

  getAllFilters(): Array<Filter> {
    let filters = [];
    if (this.data) {
      this.data.Entities.forEach(entity => {
        entity.Filters.forEach(filter => {

          if (filter.Type === FilterTypeEnum.Between) {
            this.SetBetweenFilters(filter, filters);
          } else {
            filters.push(filter);
          }
        });
      });
    }
    filters = sortListByOrder(filters);
    return filters;
  }

  SetBetweenFilters(filter: Filter, filters: Array<Filter>) {
    const auxEnd = {... filter},
     auxIni =  {... filter};

    auxEnd.Legend = '';
    auxEnd.Name = `${auxEnd.Name}_FIN`;
    auxIni.Name = `${auxIni.Name}_INI`;

    filters.push(auxIni);
    filters.push(auxEnd);
  }

  //#region  form

  convertFilterToSchemaForm(): SchemaForm {
    const form: SchemaForm = new SchemaForm(),
      rows: SchemaFormRow[] = [];

    let columns: Schema[] = [];

    this.filters.forEach((filter, index) => {
      let propertyType = getPropertyTypeBySystemType(filter.ColumnType.SystemType);

      if (filter.Type === FilterTypeEnum.Interval) {
        propertyType = PropertyType.Text;
      } else if (filter.Type === FilterTypeEnum.List) {
        propertyType = PropertyType.Select;
      } else if (filter.Type === FilterTypeEnum.MultiList) {
        propertyType = PropertyType.MultiSelect;
      }

      this.setColumnForm(filter, propertyType, columns);

      if (columns.length >= 4 || this.filters.length - 1 === index) {
        rows.push({ Columns: columns });
        columns = [];
      }
    });

    form.Rows = rows;

    return form;
  }

  private setColumnForm(filter: Filter, propertyType: PropertyType, columns: Schema[]) {
    const column = new Schema(filter.Legend, filter.Name, propertyType);
    this.setValidatorsByFilter(filter, column);

    if (filter.IsFileUpload) {
      this.schemasWithFileUpload.push(column);
    }

    if (filter.Type === FilterTypeEnum.Between && column.PropertyName.match(/(INI)$/g)) {
      column.Description = column.Description;
    }

    if (filter.Type === FilterTypeEnum.List || filter.Type === FilterTypeEnum.MultiList) {
        this.loadEntityList(column, filter.EntityListId);
    }

    columns.push(column);
  }

  setValidatorsByFilter(filter: Filter, schema: Schema) {
    schema.Required = filter.Required;
  }

  //#endregion

  //#region Filter List
  async loadEntityList(column: Schema, entityId: number) {
    const objEntityList  = new Entity;
    const page = 0;
    const amountByPage = 1;

    objEntityList.Id =  entityId;

  await this.entityService.get(objEntityList, page, amountByPage).toPromise().then(result => {
      this.entityList = result.Data[0];
    });

    this.LoadQueryEntityList(column);
  }

  LoadQueryEntityList(column: Schema) {
    const obj: QueryRequest = {
      ProviderId: this.entityList.Provider.Id,
      Query: this.entityList.Query
    };

    this.subscription.add(
      this.queryService.queryEntityList(obj).subscribe(result => {
        result.forEach(x => column.Values.push(new ObjectValue(x.Description, x.Value)));
      })
    );
  }

  //#endregion
}

